<!-- 供应商建账记录 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">供应商名称</div>
                <el-select size="small" v-model="searchData.CusId" filterable clearable remote reserve-keyword
                    :remote-method="querySearch" v-select-scroll-more="searchLoad" class="search-item">
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem"
                        :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
                <div class="search-name">发生日期</div>
                <el-date-picker class="search-item" style="width: 230px" size="small" v-model="datetime2" type="daterange"
                    align="right" unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                    :picker-options="pickerOptions" @change="onDate2TimeSelect"></el-date-picker>
                <div class="search-name">建账时间</div>
                <el-date-picker class="search-item" style="width: 230px" size="small" v-model="datetime1" type="daterange"
                    align="right" unlink-panels range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
                    :picker-options="pickerOptions" @change="onDate1TimeSelect"></el-date-picker>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" style="margin-left: 10px"
                    @click="handleSearch">查询</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border=""
                style="width: 100%; margin-bottom: 0px">
                <el-table-column show-overflow-tooltip width="170px" prop="BACode" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120px" prop="EntpCusName" label="供应商"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="TotalAmount" label="发生额"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="AlreadyPaid" label="已结金额"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column show-overflow-tooltip width="85px" prop="PayTime" label="发生日期"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="StaffName" label="建账人"></el-table-column>
                <el-table-column show-overflow-tooltip width="85px" prop="ConfirmTime" label="建账时间"></el-table-column>
                <el-table-column label="操作" :isCanSet="true" width="130">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="Permission.editAccount && scope.row.AlreadyPaid == 0" type="text" size="mini"
                                @click="showBuildAccount(scope.row)">{{ Permission.editAccount }}</el-button>
                            <el-button v-if="Permission.delAccount && scope.row.AlreadyPaid == 0" type="text"
                                style="color: red" size="small" @click="delAccount(scope.row)">{{ Permission.delAccount
                                }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="searchData.page" :page-sizes="[10, 20, 30, 40, 50]" :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper" :total="searchDataLength"></el-pagination>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                :title="entpCusName ? '【' + entpCusName + '】建账' : '建账'"
                :visible.sync="isShowBuildDialog"
                :append-to-body="true"
                v-dialog-drag
                :modal="false"
                width="400px"
                lock-scroll
                id="apply-dialog"
                style="margin-left: -100px"
            >
                <div v-if="isShowBuildDialog" class="settle-op-content">
                    <BuildAccount ref="buildAccount" @closeDialog="closeBuildDialog" :CurrentData="currentApplyRow" :IsEdit="true" :CType="1"></BuildAccount>
                </div>
            </el-dialog>
    </div>
</template>
<script>
import BuildAccount from '@/components/business/revenue_h/buildAccount';
export default {
    name: '',
    props: ['EntpCusId', 'EntpCusName', 'Permission'],
    components: {BuildAccount},
    data() {
        return {
            recordId: '',
            entpCusName: '',
            orderCode: '',
            isShowBuildDialog: false,
            currentApplyRow:{},
            loading: false,
            tableData: [],
            searchDataLength: 0,
            searchData: {
                CusId: '',
                StartDate: '',
                EndDate: '',
                HStartDate: '',
                HEndDate: '',
                Page: 1,
                Limit: 10
            },
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            datetime1: [],
            datetime2:[],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.searchData.CusId = this.EntpCusId;
        if (this.EntpCusName) {
            this.cusOptions.push({
                EntpCusId: this.EntpCusId,
                EntpCusName: this.EntpCusName
            });
        }
        this.getRecords();
    },
    methods: {
        cancel() {
            this.$emit('closeRecords');
        },
        getRecords() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement_H/GetSupBARecords',
                    hideLoading: true,
                    data: this.searchData
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data;
                    this.searchDataLength = res.count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getRecords();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getRecords();
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);

            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        },
        handleSearch() {
            this.getRecords();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.HStartDate = val[0];
                this.searchData.HEndDate = val[1];
            } else {
                this.searchData.HStartDate = '';
                this.searchData.HEndDate = '';
            }
        },
        showBuildAccount(row) {
            this.isShowBuildDialog = true;
            if (row) {
                this.currentApplyRow = row;
            }
        },
        delAccount(row) {
            let that = this;
            if (row && row.RecordId) {
                that.$confirm('您确定要删除该款项吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.loading = true;
                        that.$util
                            .axiosPost({
                                url: `/api/RevenueManagement_H/DelAccountRecords?recordId=${row.RecordId}`,
                                hideLoading: true
                            })
                            .then(res => {
                                that.$util.successMsg('删除成功');
                                for (let index = 0; index < that.tableData.length; index++) {
                                    if (that.tableData[index].RecordId == row.RecordId) {
                                        that.tableData.splice(index, 1);
                                        return;
                                    }
                                }
                            })
                            .catch(() => { })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => { });
            } else {
                this.$util.warningMsg('请刷新后重新操作');
            }
        },
        closeBuildDialog(isEdit){
            this.isShowBuildDialog = false;
            if(isEdit)
                this.getRecords();
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}

.btn-ctn {
    text-align: right;
}

.el-row {
    margin-bottom: 0px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
